document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations) => {
        const item = document.querySelector('#shopify-pc__banner__body-title');
        
        if (item) {
            console.log('Element found, converting to <p>');
            
            // Create a new <p> element
            const newElement = document.createElement('p');
            
            // Copy all attributes from the old element
            for (let attr of item.attributes) {
                newElement.setAttribute(attr.name, attr.value);
            }
            
            // Copy the inner content
            newElement.innerHTML = item.innerHTML;
            
            // Replace the old element with the new one
            item.parentNode.replaceChild(newElement, item);
            
            // Disconnect observer to stop watching
            observer.disconnect();
        }
    });
    
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Safety timeout to disconnect observer after 15 seconds
    setTimeout(() => {
        observer.disconnect();
        console.log('Observer timeout - stopped watching');
    }, 15000);
});

// Quick View: sync the gallery image and product links to the selected variant.
// The SM Recharge widget already updates price and the ATC variant; this fills
// the remaining gaps (variant image, Learn More / rating links). Scoped to
// single-option products — multi-option modals are left to the widget only.
(() => {
    document.addEventListener('click', (event) => {
        const li = event.target.closest('.js__popup-variant-select li');
        if (!li) return;

        const modal = li.closest('.js__quickview-modal');
        if (!modal) return;

        if (modal.querySelectorAll('.js__popup-variant-select').length > 1) return;

        const value = li.getAttribute('data-value');
        if (!value) return;

        const option = [...modal.querySelectorAll('[sm-rc-variant-selector] option')]
            .find((o) => o.getAttribute('data-title') === value);
        if (!option) return;

        syncQuickViewImage(modal, option.value);
        syncQuickViewLinks(modal, option.value);
    });

    function syncQuickViewImage(modal, variantId) {
        const swiper = modal.querySelector('.js__popup-collection-slider')?.swiper;
        if (!swiper) return;
        const slides = swiper.slides;
        for (let i = 0; i < slides.length; i++) {
            const ids = slides[i].getAttribute('data-variant-id');
            if (ids && ids.split(' ').indexOf(variantId) !== -1) {
                swiper.slideTo(i);
                return;
            }
        }
    }

    function syncQuickViewLinks(modal, variantId) {
        modal.querySelectorAll('.js__quickview-variant-link').forEach((link) => {
            const base = (link.getAttribute('href') || '').split('?')[0];
            if (base) link.setAttribute('href', `${base}?variant=${variantId}`);
        });
    }
})();

// The cart drawer's footer is fixed, and its height varies with the discount rows and
// whichever wallet buttons Shopify renders, so the drawer's bottom padding tracks it.
document.addEventListener('DOMContentLoaded', () => {
    const cartSidebar = document.getElementById('CartSidebar');
    const cartFooter = document.querySelector('.js__cart-sidebar-footer');
    if (!cartSidebar || !cartFooter || !('ResizeObserver' in window)) return;

    new ResizeObserver(() => {
        cartSidebar.style.setProperty('padding-bottom', `${cartFooter.offsetHeight + 10}px`, 'important');
    }).observe(cartFooter);
});

// Records whether the visitor last used a pointer or the keyboard, so custom.css can hide
// the focus ring after clicks and taps. Typing keys don't count, so typing in a field
// after clicking into it keeps the ring hidden.
(() => {
    const alwaysKeyboardKeys = ['Tab', 'Escape'];
    const outsideFieldKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', ' ', 'Home', 'End', 'PageUp', 'PageDown'];
    const isTextEntry = (el) => el.isContentEditable || el.matches('input:not([type=checkbox], [type=radio], [type=button], [type=submit], [type=reset]), textarea, select');
    const setInput = (type) => {
        if (document.documentElement.dataset.iwInput !== type) document.documentElement.dataset.iwInput = type;
    };

    document.addEventListener('pointerdown', () => setInput('pointer'), true);
    document.addEventListener('keydown', (e) => {
        if (alwaysKeyboardKeys.includes(e.key) || (outsideFieldKeys.includes(e.key) && !isTextEntry(e.target))) {
            setInput('keyboard');
        }
    }, true);
})();

// Header menu videos (mega menu cards, mobile Practitioner row) are several MB each and sit
// in closed menus, so they load on the first pointer or keyboard interaction with the header
// instead of with the page. Only videos rendered at the current breakpoint load (the desktop
// mega menu is display:none on mobile); the rest wait for a later interaction.
(() => {
    const header = document.getElementById('shopify-section-header');
    if (!header || !header.querySelector('.js-lazy-video')) return;
    const interaction = new AbortController();
    const loadVideos = () => {
        header.querySelectorAll('.js-lazy-video').forEach((video) => {
            const sources = video.querySelectorAll('source[data-src]');
            if (!sources.length || !video.getClientRects().length) return;
            if (video.dataset.poster) video.poster = video.dataset.poster;
            sources.forEach((source) => {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
            });
            video.load();
        });
        if (!header.querySelector('.js-lazy-video source[data-src]')) interaction.abort();
    };
    ['pointerover', 'focusin'].forEach((type) => {
        header.addEventListener(type, loadVideos, { passive: true, signal: interaction.signal });
    });
})();
